/** How many page numbers are shown before the list is windowed around the current one. */
const MAX_VISIBLE_PAGES = 7;

/**
 * The page numbers to show, windowed around the current one.
 *
 * A set with two hundred pages would otherwise render two hundred buttons and
 * make the control the widest thing on the screen.
 */
export function buildVisiblePages(pageCount: number, pageIndex: number): number[] {
  if (pageCount <= MAX_VISIBLE_PAGES) {
    return Array.from({ length: Math.max(pageCount, 0) }, (_, index) => index);
  }

  const half = Math.floor(MAX_VISIBLE_PAGES / 2);
  const start = Math.min(Math.max(pageIndex - half, 0), pageCount - MAX_VISIBLE_PAGES);
  return Array.from({ length: MAX_VISIBLE_PAGES }, (_, index) => start + index);
}
